/* global CONFIG */
module.exports = CONFIG
